const Envs = {
  PUBLIC_URL: process.env.PUBLIC_URL,
  REACT_APP_BASE_URL: process.env.REACT_APP_BASE_URL,
  REACT_APP_PLAYER_VISITS_API_RESOURCE:
    process.env.REACT_APP_PLAYER_VISITS_API_RESOURCE,
  REACT_APP_HOURLY_API_RESOURCE: process.env.REACT_APP_HOURLY_API_RESOURCE,
  REACT_APP_ATM_USER_API_RESOURCE: process.env.REACT_APP_ATM_USER_API_RESOURCE,
  REACT_APP_LOGOUT_RESOURCE: process.env.REACT_APP_LOGOUT_RESOURCE,
  REACT_APP_LOGIN_RESOURCE: process.env.REACT_APP_LOGIN_RESOURCE,
  REACT_APP_EMPLOYEE_SWEEPS_API_RESOURCE:
    process.env.REACT_APP_EMPLOYEE_SWEEPS_API_RESOURCE,
  REACT_APP_VISIT_API_RESOURCE: process.env.REACT_APP_VISIT_API_RESOURCE,
  REACT_APP_FORGOT_PASSWORD_RESOURCE:
    process.env.REACT_APP_FORGOT_PASSWORD_RESOURCE,
  REACT_APP_RESET_PASSWORD_RESOURCE:
    process.env.REACT_APP_RESET_PASSWORD_RESOURCE,
  REACT_APP_VERIFY_OTP_RESOURCE: process.env.REACT_APP_VERIFY_OTP_RESOURCE,
  REACT_APP_SALT_RESOURCE: process.env.REACT_APP_SALT_RESOURCE,
  REACT_APP_NEW_PASSWORD: process.env.REACT_APP_NEW_PASSWORD,
  REACT_APP_ACCEPT_TERMS: process.env.REACT_APP_ACCEPT_TERMS,
  REACT_APP_VERSION: process.env.REACT_APP_VERSION,
  REACT_APP_USERS_RESOURCE: process.env.REACT_APP_USERS_RESOURCE,
  REACT_APP_ORGANIZATION_UNIT_RESOURCE:
    process.env.REACT_APP_ORGANIZATION_UNIT_RESOURCE,
  REACT_APP_RESEND_EMAIL_RESOURCE: process.env.REACT_APP_RESEND_EMAIL_RESOURCE,
  REACT_APP_GET_USER_DETAIL_RESOURCE:
    process.env.REACT_APP_GET_USER_DETAIL_RESOURCE,
  REACT_APP_REFRESH_TOKEN_RESOURCE:
    process.env.REACT_APP_REFRESH_TOKEN_RESOURCE,
  REACT_APP_ACTIVATE_DEACTIVATE_USER_RESOURCE:
    process.env.REACT_APP_ACTIVATE_DEACTIVATE_USER_RESOURCE,
  REACT_APP_COMPLETE_ONBOARDING_RESOURCE:
    process.env.REACT_APP_COMPLETE_ONBOARDING_RESOURCE ||
    'users/complete-onboarding',
  REACT_APP_DELETE_USER_RESOURCE: process.env.REACT_APP_DELETE_USER_RESOURCE,
  REACT_APP_CREATE_ORGANIZATION_RESOURCE:
    process.env.REACT_APP_CREATE_ORGANIZATION_RESOURCE,
  REACT_APP_VENUE_UPDATE_RESOURCE: process.env.REACT_APP_VENUE_UPDATE_RESOURCE,
  REACT_APP_LOGIN_AS_STAFF: process.env.REACT_APP_LOGIN_AS_STAFF,
  REACT_APP_VENUE_STAFF_SALT: process.env.REACT_APP_VENUE_STAFF_SALT_RESOURCE,
  REACT_APP_CREATE_USER_RESOURCE: process.env.REACT_APP_CREATE_USER_RESOURCE,
  REACT_APP_UPDATE_PROFILE_RESOURCE:
    process.env.REACT_APP_UPDATE_PROFILE_RESOURCE,
  REACT_APP_UPDATE_USER_RESOURCE: process.env.REACT_APP_UPDATE_USER_RESOURCE,
  REACT_APP_CHANGE_USER_PROFILE_RESOURCE:
    process.env.REACT_APP_CHANGE_USER_PROFILE_RESOURCE,
  REACT_APP_GET_SWEEPS: process.env.REACT_APP_GET_SWEEPS,
  REACT_APP_GET_VENUE_OPENING_HOURS:
    process.env.REACT_APP_GET_VENUE_OPENING_HOURS,
  REACT_APP_SWEEP_UPDATE: process.env.REACT_APP_SWEEP_UPDATE,
  REACT_APP_APPROVE_SWEEP_REPORT: process.env.REACT_APP_APPROVE_SWEEP_REPORT,
  REACT_APP_DELETE_SWEEPS_RESOURCE:
    process.env.REACT_APP_DELETE_SWEEPS_RESOURCE,
  REACT_APP_DOWNLOAD_SWEEPS_RESOURCE:
    process.env.REACT_APP_DOWNLOAD_SWEEPS_RESOURCE,
  REACT_APP_GET_SWEEP_HISTORY_RESOURCE:
    process.env.REACT_APP_GET_SWEEP_HISTORY_RESOURCE,
  REACT_APP_HARM_REPORT_RESOURCE: process.env.REACT_APP_HARM_REPORT_RESOURCE,
  REACT_APP_INTERVENTION_REPORT_RESOURCE:
    process.env.REACT_APP_INTERVENTION_REPORT_RESOURCE,
  REACT_APP_NOTIFICATION_SUBSCRIPTION_RESOURCE:
    process.env.REACT_APP_NOTIFICATION_SUBSCRIPTION_RESOURCE,
  REACT_APP_WEBSOCKET_URL: process.env.REACT_APP_WEBSOCKET_URL,
  REACT_APP_AUTH_USERS_RESOURCE: process.env.REACT_APP_AUTH_USERS_RESOURCE,
  REACT_APP_VAPID_PUBLIC_KEY: process.env.REACT_APP_VAPID_PUBLIC_KEY,
  REACT_APP_SEND_USER_VERIFICATION_CODE_RESOURCE:
    process.env.REACT_APP_SEND_USER_VERIFICATION_CODE_RESOURCE,
  REACT_APP_VERIFY_USER_VERIFICATION_CODE:
    process.env.REACT_APP_VERIFY_USER_VERIFICATION_CODE,
};

export const getEnvironmentVariable = <Key extends keyof typeof Envs>(
  key: Key,
): NonNullable<(typeof Envs)[Key]> => {
  const x = Envs[key];
  if (!x) {
    throw new Error(`Environment variable not found: ${key}`);
  } else return x;
};
